<form
  [formGroup]="form"
  *ngIf="form && formInitialized"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-tag-dropdown
      [colSize]="5"
      formControlName="tags"
      mode="all"></app-tag-dropdown>
    <app-form-field-wrapper [colSize]="4" label="Themenbereich" name="parent">
      <p-dropdown
        *ngIf="categoryStore.asArray() as categories"
        id="category"
        formControlName="category"
        [lazy]="true"
        [filter]="true"
        [filterFields]="['title']"
        [options]="categories"
        [showClear]="true"
        optionLabel="title"
        optionValue="_id"
        dataKey="_id">
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-layer-group"></i>
            <div>{{ item.title }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [colSize]="3"
      label="öffentlich sichtbar"
      name="published"
      [floatingLabel]="true">
      <p-inputSwitch id="published" formControlName="published"></p-inputSwitch>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Beschreibung'" [name]="'description'">
      <textarea
        pInputTextarea
        id="description"
        formControlName="description"
        class="p-inputtextarea"></textarea>
    </app-form-field-wrapper>
  </div>

  <app-header
    text="Welche Ansichten sollen abgebildet werden?"
    icon="fas fa-note-sticky"></app-header>
  <div
    class="card"
    *ngIf="bookmarkStore.initialized() && categoryStore.initialized()">
    <p-pickList
      [source]="bookmarks"
      [target]="storyBookmarks"
      sourceHeader="Ansichten"
      targetHeader="Auswahl"
      [showSourceControls]="false"
      [dragdrop]="true"
      [responsive]="true"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      filterBy="title"
      sourceFilterPlaceholder="Suche"
      targetFilterPlaceholder="Suche"
      breakpoint="1400px">
      <ng-template let-bookmark pTemplate="item">
        <div
          *ngIf="bookmark"
          class="flex flex-wrap p-2 align-items-center gap-3">
          <i class="fas fa-note-sticky"></i>
          {{ bookmark.title }}
          <ng-container
            *ngFor="
              let categoryId of bookmarkCategoryHelper.getCategoriesForBookmark(
                bookmark._id
              )
            ">
            <p-tag
              *ngIf="categoryStore.getById(categoryId) as category"
              [rounded]="true"
              icon="fas fa-folder"
              styleClass="p-tag-category"
              [value]="category.title"></p-tag>
          </ng-container>
        </div>
        <div *ngIf="itemToEdit && itemToEdit.tags">
          <app-tag-list [tagIds]="itemToEdit.tags" />
        </div>
      </ng-template>
    </p-pickList>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        itemToEdit.category &&
        permissionService.checkBookmarkRights(itemToEdit.category, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
